module.exports = __webpack_public_path__ + "static/media/residential-security.34ef8c06.jpg";